<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8 pb-12">
    <div class="text-center">
      <h2
        class="text-2xl tracking-wide leading-10 font-extrabold font-open-sans text-white mt-4 sm:text-5xl sm:leading-none md:text-4xl"
      >
        Behind the Vectric Curtains
      </h2>
      <div class="mt-6">
        <video controls class="w-full">
          <source
            src="https://firebasestorage.googleapis.com/v0/b/usergroupmeeting-2021-1c57f.appspot.com/o/public%2FWorkshop_Tour_2B.mp4?alt=media&token=493dae2b-3715-415c-9dbc-157879ff90e6"
          />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tour"
};
</script>

<style scoped></style>
